// constants
import { MESSAGE_COMMUNICATION_ROLE, MESSAGE_SEND_STATUS, CHAT_TYPE } from '@/globals';

// libs
import moment from 'moment';

// components
import CoreTooltip from '@corefront/components-v2/Core/CoreTooltip.vue';
import CoreAvatar from '@corefront/components-v2/Core/CoreAvatar.vue';
import ChatSeenIndicator from '@corefront/components-v2/Chat/ChatSeenIndicator.vue';
import ChatBubbleAttachments from '@corefront/components-v2/Chat/ChatBubbleAttachments.vue';
import IconTrash from '@corefront/components-v2/Icon/IconTrash';
import IconLoading from '@corefront/components-v2/Icon/IconLoading';

// utils
import { parseHtml } from '@corefront/utils/parseHtml';
export default {
  components: {
    CoreTooltip,
    CoreAvatar,
    ChatSeenIndicator,
    ChatBubbleAttachments,
    IconTrash,
    IconLoading
  },
  props: {
    message: {
      type: String,
      default: ''
    },
    attachments: {
      type: Array,
      default: () => []
    },
    communicationRole: {
      type: String,
      required: true,
      validator(val) {
        return Object.values(MESSAGE_COMMUNICATION_ROLE).includes(val);
      }
    },
    avatarUrl: {
      type: String,
      default: ''
    },
    avatarText: {
      type: String,
      default: ''
    },
    sentDateUnix: {
      type: Number,
      default: new Date().valueOf()
    },
    senderName: {
      type: String,
      default: ''
    },
    sendStatus: {
      type: String,
      default: MESSAGE_SEND_STATUS.SENT
    },
    eventName: {
      type: String,
      default: null
    },
    messageType: {
      type: String,
      default: null
    },
    hideAvatar: {
      type: Boolean,
      default: false
    },
    hideName: {
      type: Boolean,
      default: false
    },
    bubbleBackgroundClass: {
      type: String,
      default: ''
    },
    seen: {
      type: Boolean,
      default: false
    },
    seenDateUnix: {
      type: Number,
      default: new Date().valueOf()
    },
    articles: {
      type: Array,
      default: () => []
    },
    retryFailedFn: {
      type: Function,
      default: () => ({})
    },
    deleteFailedFn: {
      type: Function,
      default: () => ({})
    }
  },
  emits: ['retry-failed', 'delete-failed'],
  data() {
    return {
      showSuccessBar: false,
      isDeletingFailedMessage: false,
      isRetryingFailedMessage: false
    };
  },
  computed: {
    MESSAGE_SEND_STATUS: () => MESSAGE_SEND_STATUS,
    CHAT_TYPE: () => CHAT_TYPE,
    articleClasses() {
      const {
        articles,
        message
      } = this;
      return [message.length > 0 || articles.length > 1 ? 'cf-bg-white cf-border cf-rounded-md cf-border-solid cf-border-silver-gray cf-p-3' : '', articles.length > 1 ? 'cf-mb-2' : ''];
    },
    bubbleBackgroundColor() {
      const {
        sendStatus,
        isSender,
        messageType,
        articles,
        message
      } = this;
      if (sendStatus === MESSAGE_SEND_STATUS.FAILED) {
        return 'cf-bg-deep-rose/20 cf-border cf-border-solid cf-border-deep-rose';
      }
      if (this.bubbleBackgroundClass) {
        return this.bubbleBackgroundClass;
      }
      if (articles.length == 1 && message.length === 0) {
        return 'cf-bg-white cf-border cf-border-solid cf-border-silver-gray';
      }
      if (messageType === CHAT_TYPE.NOTES) {
        return 'cf-bg-golden-rod';
      }
      if (messageType === CHAT_TYPE.EVENT) {
        return isSender ? 'cf-bg-pale-sky' : 'cf-bg-white cf-border cf-border-solid cf-border-silver-gray';
      }
      return isSender ? 'cf-bg-pale-sky' : 'cf-bg-silver-gray';
    },
    isSender() {
      return this.communicationRole === MESSAGE_COMMUNICATION_ROLE.SENDER;
    },
    sentDateFormatted() {
      return moment(this.sentDateUnix * 1000).format('h:mmA MM/DD/YY');
    }
  },
  watch: {
    sendStatus(newValue, oldValue) {
      if (newValue === MESSAGE_SEND_STATUS.SENT && oldValue === MESSAGE_SEND_STATUS.PENDING) {
        this.showSuccessBar = true;
        setTimeout(() => {
          this.showSuccessBar = false;
        }, 500);
      }
    }
  },
  methods: {
    parseHtml,
    async onDelete() {
      if (this.isDeletingFailedMessage) {
        return;
      }
      try {
        this.isDeletingFailedMessage = true;
        await this.deleteFailedFn({
          message: this.message
        });
      } finally {
        this.isDeletingFailedMessage = false;
      }
    },
    async onRetry() {
      if (this.isRetryingFailedMessage) {
        return;
      }
      try {
        this.isRetryingFailedMessage = true;
        await this.retryFailedFn({
          message: this.message
        });
      } finally {
        this.isRetryingFailedMessage = false;
      }
    }
  }
};